import { IconAlertTriangleFilled, IconProps } from '@tabler/icons-react'

import IconWrapper from './IconWrapper'

const WarningIcon = (props: IconProps) => {
	return <IconWrapper icon={IconAlertTriangleFilled} {...props} />
}

export default WarningIcon
